// @ts-expect-error: Ember Simple Auth is not typed
import JWTAuthenticator from '@triptyk/ember-simple-auth-token/authenticators/jwt';

export default class SessionAuthenticator extends JWTAuthenticator {
  authenticate(session: object) {
    // @ts-expect-error: handleAuthResponse exists on the parent class
    return Promise.resolve(this.handleAuthResponse(session));
  }
}
